import script from "./EvalModelDeleter.vue?vue&type=script&setup=true&lang=ts"
export * from "./EvalModelDeleter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__